import { render, staticRenderFns } from "./section-info-col-type-date.vue?vue&type=template&id=3a0edeab&scoped=true&"
import script from "./section-info-col-type-date.ts?vue&type=script&lang=ts&"
export * from "./section-info-col-type-date.ts?vue&type=script&lang=ts&"
import style0 from "./section-info-col-type-date.scss?vue&type=style&index=0&id=3a0edeab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0edeab",
  null
  
)

export default component.exports